import * as React from "react";
import type { SVGProps } from "react";
const SvgCoinBroken = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.2 3.977a6.982 6.982 0 0 1 9.826 9.823m-3.663.818a6.982 6.982 0 1 1-13.964 0 6.982 6.982 0 0 1 13.964 0"
    />
  </svg>
);
export default SvgCoinBroken;
